import React from "react";
import AcademyMenu from "./components/AcademyMenu";
import MobileWarning from "components/MobileWarning";
import DashboardChatbot from "components/DashboardChatbot";
import DashboardTopBar from "components/DashboardTopBar";
import BillingRecoveryBanner from "components/BillingRecoveryBanner";
import { useAppSelector } from "store";
import { useMediaQuery } from "hooks/useMediaQuery";

const AcademyLayout = ({ children, restrictOnMobile }: { children: React.ReactNode; restrictOnMobile?: boolean }) => {
  const { isAuthorized, isChatbotOpen } = useAppSelector((state) => state.common);
  // Mirror Layout's mobile gating — AcademyLayout-based routes (e.g. all-courses)
  // also fall back to the desktop warning when restricted on the mobile shell.
  const isMobileShell = useMediaQuery("(max-width: 833px)");

  return (
    // Padding lives on the content wrapper, not here: on desktop DashboardChatbot is an
    // in-flow `sticky h-screen shrink-0` flex sibling (w-[420px] open, w-0 closed), so any
    // padding or gap on this element would leave a white band between the page and the panel
    // and stop it reaching the viewport edge. Layout.tsx has the same arrangement.
    <main
      className="bg-white flex w-full"
      style={{
        minHeight: "100dvh",
      }}
    >
      {restrictOnMobile && isMobileShell ? (
        <div className="flex w-full flex-col">
          {/* P7 Faz 1: the payment-problem banner shows above the mobile restriction too. */}
          <BillingRecoveryBanner />
          <div className="flex min-h-[calc(100dvh-40px)] w-full items-center justify-center p-5">
            <MobileWarning />
          </div>
        </div>
      ) : (
        <>
          {/* data-chatbot-* drive the grid reductions in DashboardChatbot/chatbot.css, so the
              course grid reflows instead of being squeezed when the panel opens. `min-w-0` is
              required on both flex columns: a flex child defaults to min-width:auto, which
              makes the page scroll sideways rather than shrink once the panel takes 420px. */}
          <div className="flex flex-1 min-w-0 gap-10 p-5" data-chatbot-body="true" data-chatbot-open={isChatbotOpen ? "true" : undefined}>
            <AcademyMenu />
            <div className="flex flex-1 min-w-0 flex-col">
              {/* P7 Faz 1: the plan's payment failed — said here too (this route has its own shell). */}
              <BillingRecoveryBanner />
              {/* Carries the only Ask Agent launcher. Without it this route had the chatbot
                  neither mounted nor openable, so its `academy` page context was unreachable. */}
              {isAuthorized && !isMobileShell && <DashboardTopBar />}
              <div className="flex flex-1">{children}</div>
            </div>
          </div>
          {isAuthorized && <DashboardChatbot />}
        </>
      )}
    </main>
  );
};

export default AcademyLayout;
